import {
  DESIGN_IMPORT_TYPE_ID,
  CUSTOM_SIZE_TYPE_ID,
} from 'constants/designType';

export const EDITOR_ACTION_START = 'EDITOR_ACTION_START';
export const EDITOR_ACTION_ERROR = 'EDITOR_ACTION_ERROR';
export const EDITOR_LOAD_USER_INFO_ACTION_SUCCESS = 'EDITOR_LOAD_USER_INFO_ACTION_SUCCESS';
export const EDITOR_FINISH_PRODUCT_DESIGN_ACTION_SUCCESS = 'EDITOR_FINISH_PRODUCT_DESIGN_ACTION_SUCCESS';
export const EDITOR_REMOVE_CURRENT_SURFACE_ACTION_SUCCESS = 'EDITOR_REMOVE_CURRENT_SURFACE_ACTION_SUCCESS';
export const EDITOR_ADD_SURFACE_ACTION_SUCCESS = 'EDITOR_ADD_SURFACE_ACTION_SUCCESS';
export const EDITOR_UPDATE_SUCCESS = 'EDITOR_UPDATE_SUCCESS';
export const EDITOR_RESET_STATE = 'EDITOR_RESET_STATE';
export const EDITOR_SWAP_SURFACE_ACTION_SUCCESS = 'EDITOR_SWAP_SURFACE_ACTION_SUCCESS';

function editorActionStart() {
  return {
    type: EDITOR_ACTION_START,
  };
}

function editorActionError(error) {
  return {
    type: EDITOR_ACTION_ERROR,
    error,
  };
}

function editorLoadUserInfoSuccess(userInfo) {
  return {
    type: EDITOR_LOAD_USER_INFO_ACTION_SUCCESS,
    userInfo,
  };
}

function editorFinishProductDesignSuccess() {
  return {
    type: EDITOR_FINISH_PRODUCT_DESIGN_ACTION_SUCCESS,
  };
}

function editorRemoveCurrentSurfaceSuccess() {
  return {
    type: EDITOR_REMOVE_CURRENT_SURFACE_ACTION_SUCCESS,
  };
}

function editorAddSurfaceSuccess() {
  return {
    type: EDITOR_ADD_SURFACE_ACTION_SUCCESS,
  };
}

function editorSwapSurfaceSuccess() {
  return {
    type: EDITOR_SWAP_SURFACE_ACTION_SUCCESS,
  };
}

export function editorUpdate(editor) {
  return {
    type: EDITOR_UPDATE_SUCCESS,
    editor,
  };
}

export function resetEditorState() {
  return {
    type: EDITOR_RESET_STATE,
  };
}

export function editorLoadUserInfo(userInfo) {
  return (dispatch, getState) => {
    const editor = getState().editor.getIn(['data', 'editor']);
    dispatch(editorActionStart());
    return editor.loadUserInfo(userInfo)
    .then(() => {
      dispatch(editorLoadUserInfoSuccess(userInfo));
      return true;
    })
    .catch((error) => {
      dispatch(editorActionError(error));
    });
  };
}

export function editorFinishProductDesign(stateFileId, silent = false, proofMaxHeightVal = 500, proofMaxWidthVal = 500) {
  return (dispatch, getState) => {
    const editor = getState().editor.getIn(['data', 'editor']);
    if (!silent) {
      dispatch(editorActionStart());
    }
    return editor.finishProductDesign({stateId:stateFileId, proofMaxHeight: proofMaxHeightVal, proofMaxWidth: proofMaxWidthVal})
    .then((result) => {
      dispatch(editorFinishProductDesignSuccess());
      return result;
    })
    .catch((error) => {
      dispatch(editorActionError(error));
      throw (error);
    });
  };
}

export function editorRemoveCurrentSurface(pageIndex) {
  return (dispatch, getState) => {
    const editor = getState().editor.getIn(['data', 'editor']);
    dispatch(editorActionStart());
    return editor.getProduct()
    .then(product => {
      const surfaces = product.surfaces;
      if (surfaces.length) {
        return product.removeSurface(surfaces[pageIndex])
        .then(() => {
          dispatch(editorRemoveCurrentSurfaceSuccess());
        });
      }
    })
    .catch(error => {
      dispatch(editorActionError(error));
    });
  }
}

/**
 * Add a customers canvas new design page
 * For custom design isCustomDesign is true and
 * a blank ProductDefinition will be created
 * with the width and height of the currentSurface
 * @param {string} surfaceTemplate
 * @param {number} pageIndex
 * @param {Number} designType
 * @returns
 */
export function editorAddSurface(surfaceTemplate, pageIndex, designType) {
  return (dispatch, getState) => {
    const editor = getState().editor.getIn(['data', 'editor']);
    dispatch(editorActionStart());
    return editor.getProduct()
      .then(product => {
        let surface;
        switch (designType) {
          case CUSTOM_SIZE_TYPE_ID:
            surface = {
              width: product.currentSurface.width,
              height: product.currentSurface.height,
            };
            break;

          case DESIGN_IMPORT_TYPE_ID:
            surface = {
              stateId: surfaceTemplate,
              surface: pageIndex <= 1 ? 0 : pageIndex - 1, // index has to be non-negative
            };
            break;

          default:
            surface = {
              stateId: surfaceTemplate,
            }
            break;
        }
        return product.addSurface(surface, pageIndex)
          .then(() => {
            dispatch(editorAddSurfaceSuccess());
          });
      })
      .catch(error => {
        dispatch(editorActionError(error));
      });
  };
}

export function editorSwapSurface(preSurface, nextSurface) {
  return (dispatch, getState) => {
    const editor = getState().editor.getIn(['data', 'editor']);
    dispatch(editorActionStart());
    return editor.getProduct()
    .then(product => {
      const surfaces = product.surfaces;
      if (surfaces.length && surfaces.length > 1) {
        return product.swapSurfaces(surfaces[preSurface], surfaces[nextSurface])
        .then(() => {
          dispatch(editorSwapSurfaceSuccess());
        });
      }
    })
    .catch(error => {
      dispatch(editorActionError(error));
    });
  }
}

/**
 * Add a customers canvas new duplicated design page
 * For custom design isCustomDesign is true and
 * a blank ProductDefinition will be created
 * with the width and height of the currentSurface
 * @param {string} surfaceTemplate
 * @param {number} pageIndex
 * @param {Number} designType
 * @returns
 */
export function editorDuplicateSurface(surfaceTemplate, pageIndex, designType) {
  return async (dispatch, getState) => {
    const editor = getState().editor.getIn(['data', 'editor']);
    dispatch(editorActionStart());
    await editor.saveProduct(surfaceTemplate);
    return await editor.getProduct()
      .then(product => {
        let surface;
        switch (designType) {
          case CUSTOM_SIZE_TYPE_ID:
            surface = {
              width: product.currentSurface.width,
              height: product.currentSurface.height,
              stateId: surfaceTemplate,
              surface: pageIndex <= 1 ? 0 : pageIndex - 1,
            };
            break;

          case DESIGN_IMPORT_TYPE_ID:
            surface = {
              stateId: surfaceTemplate,
              surface: pageIndex <= 1 ? 0 : pageIndex - 1, // index has to be non-negative
            };
            break;

          default:
            surface = {
              stateId: surfaceTemplate,
              surface: pageIndex <= 1 ? 0 : pageIndex - 1,
            }
            break;
        }
        return product.addSurface(surface, pageIndex)
          .then(() => {
            dispatch(editorAddSurfaceSuccess());
          });
      })
      .catch(error => {
        dispatch(editorActionError(error));
      });
  };
}